import { createTheme } from '@material-ui/core/styles'
//import variables from './sass/_variables.scss'

const variables = {
  whitecolor: '#ffffff',
  btnbackground: '#F67131',
  btnhover: '#f57d43'
}

const theme = createTheme({
  typography: {
    fontFamily: '"Poppins", sans-serif !important'
  },
  palette: {
    common: {
      dialogBackground: 'rgba(224, 239, 243, 0.05)'
    }
  },
  overrides: {
    MuiButton: {
      root: {
        textTransform: 'none',
        fontSize: 14
      },
      contained: {
        backgroundColor: variables.btnbackground,
        boxShadow: 'none',
        color: variables.whitecolor,
        '&:hover': {
          backgroundColor: variables.btnhover
        }
      },
      outlined: {
        color: variables.btnbackground,
        border: `1px solid ${variables.btnbackground}`,
        //boxShadow: '0px 1px 5px 0px rgba(0,0,0,0.2), 0px 2px 2px 0px rgba(0,0,0,0.14), 0px 3px 1px -2px rgba(0,0,0,0.12)',
        marginRight: 10,
        '&:hover': {
          backgroundColor: variables.btnbackground,
          color: variables.whitecolor
        }
      }
    },
    MuiInputBase: {
      input: {
        padding: 8
      }
    },
    MuiFormControl: {
      root: {
        width: '100%' //Controls the width of textfields.
      }
    },
    MuiInputLabel: {
      root: {
        fontWeight: 500
      }
    },
    MuiPaper: {
      elevation24: {
        boxShadow: '0px 2px 4px'
      }
    },
    MuiMenuItem: {
      root: {
        fontSize: '12px',
        paddingTop: '12px',
        paddingBottom: '12px'
      }
    },
    MuiSelect: {
      icon: {
        top: 'auto',
        fontSize: '24px'
      }
    }
  }
})

export default theme
